export default __webpack_public_path__ + "8eec82e51baaed0ddee676c743c34442.png";